import { BOA_KEY, InUrls, VERSION } from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  getXMLData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getInsuranceTypes = async () => {
  return await getData(BOA_KEY + VERSION + InUrls.GET_INSURANCE_TYPES);
};
export const getInsuranceDocument = async (
  userId,
  documentId,
  documentName = "document.pdf"
) => {
  const name = documentName.split(".");
  return await getXMLData(
    BOA_KEY +
      VERSION +
      `${userId}/${InUrls.DOWNLOAD_INSURANCE_DOCUMENT}?insuranceDocumentId=${documentId}`,
    name[0] || "document",
    "." + name[1] || ".pdf"
  );

  // return await getData(
  //   `${userId}/${InUrls.DOWNLOAD_INSURANCE_DOCUMENT}?insuranceDocumentId=${documentId}`
  // );
};

export const getUserInsurance = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${InUrls.USER_INSURANCES}`);
};

export const updateUserInsurance = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${InUrls.USER_INSURANCES}`,
    data
  );
};

export const uploadInsuranceDocuement = async (data, id) => {
  return await postData(
    BOA_KEY + VERSION + `${id}/${InUrls.INSURANCE_DOCUMENT}`,
    data
  );
};

export const deleteInsuranceDocument = async (key, id) => {
  let url = BOA_KEY + VERSION + `${id}/${InUrls.INSURANCE_DOCUMENT}`;
  return await deleteData(url, key);
};
